import React, { useEffect, useState } from "react";
import "../styles/TeamSection.css";
import api from "../api/axios";

const TeamSection = () => {
  const [teamMembers, setTeamMembers] = useState([]);

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const res = await api.get("companyblog/teams/");
        const formattedData = res.data.data.map((member) => ({
          id: member.id,
          name: member.team_name,
          position: member.position,
          image: member.image,
          socialLinks: {
            facebook: member.social_facebook,
            twitter: member.social_insta, // mapped intentionally
            linkedin: member.social_linkedin,
          },
        }));

        setTeamMembers(formattedData);
      } catch (error) {
        console.error("Failed to fetch team members", error);
      }
    };

    fetchTeamMembers();
  }, []);

  const TeamMember = ({ member }) => {
    return (
      <div className="col-lg-3 col-md-6 mb-4">
        <div className="person">
          <figure>
            <img
              src={member.image}
              alt={member.name}
              className="img-fluid"
              loading="lazy"
            />
            <div className="social">
              {member.socialLinks.facebook && (
                <a href={member.socialLinks.facebook} target="_blank" rel="noreferrer">
                  <span className="fab fa-facebook-f"></span>
                </a>
              )}
              {member.socialLinks.twitter && (
                <a href={member.socialLinks.twitter} target="_blank" rel="noreferrer">
                  <span className="fab fa-x-twitter"></span>
                </a>
              )}
              {member.socialLinks.linkedin && (
                <a href={member.socialLinks.linkedin} target="_blank" rel="noreferrer">
                  <span className="fab fa-linkedin-in"></span>
                </a>
              )}
            </div>
          </figure>

          <div className="person-contents">
            <h3>{member.name}</h3>
            <span className="position">{member.position}</span>
          </div>
        </div>
      </div>
    );
  };

  if (!teamMembers.length) return null;

  return (
    <section className="teams-area teams-nine" id="team">
      <div className="section-title-six">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="content">
                <h6>Teams</h6>
                <h2 className="fw-bold">Our Members</h2>
                <p>
                 While team members are dedicated professionals committed to delivering reliable, high-quality solutions with integrity and expertise.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="content">
        <div className="container">
          <div className="row">
            {teamMembers.map((member) => (
              <TeamMember key={member.id} member={member} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
